let ready = null;

export const menuItems = (id, path) => {
  if (ready !== null) {
    return ready;
  }

  ready = Array.from(document.getElementById(id).children).map((item) => {
    const items = Array.from(item.children).map((item) => {
      const href = item.getAttribute('href');
      const active = path === href || `/${path.split('/')[1]}` === href;
      return {
        name: item.innerHTML,
        img: item.dataset.img,
        lvl: item.dataset.lvl,
        href,
        active,
      };
    });

    const active = items.find((i) => i.active) !== undefined;
    const links = items.reduce((acc, link) => {
      if (link.lvl === '2') {
        acc.push(link);
      }
      return acc;
    }, []);

    const sub = {
      name: item.dataset.name,
      id: parseInt(item.dataset.id, 10),
      items: links,
      img: item.dataset.img,
      href: item.dataset.href,
      active,
    };
    return sub;
  });

  return ready;
};
